import React, { useEffect, useRef } from 'react';
import PT from 'prop-types';
import { MDCRipple } from '@material/ripple';
import cIf from 'classnames';
import { Icon } from './icon';

export function IconButton({ classNames, icon, onClick }) {
    const iconButtonRef = useRef(null);
        
    useEffect(() => {
        // Note: we need to instanciate MDCRipple here, since it's required by Material Design
        //eslint-disable-next-line sonarjs/constructor-for-side-effects
        new MDCRipple(iconButtonRef.current);
    });

    return <button className={cIf(["icon-button", classNames])} ref={iconButtonRef} onClick={onClick}>
        <Icon className={icon.className} tooltip={(icon.tooltip ? icon.tooltip : "")} label={(icon.label ? icon.label : "")} />
    </button>;
}
IconButton.propTypes = {
    classNames: PT.oneOfType([
        PT.string,
        PT.array
    ]),
    icon: PT.shape({
        className: PT.string,
        label: PT.string,
        tooltip: PT.string
    }),
    tooltip: PT.string,
    onClick: PT.func
};
